import React, { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { adsAPI } from "../services/api";
import { formatPrice } from "../utils/helpers";

const isExpired = (ad) => ad.end_date && new Date(ad.end_date) < new Date();

const getStatusInfo = (ad) => {
  if (ad.status === "pending")  return { text: "⏳ Pendiente de revision", bg: "#fff8e1", color: "#b7830a" };
  if (ad.status === "rejected") return { text: "❌ Rechazada",             bg: "#FEE",    color: "#e24b4a" };
  if (ad.status === "inactive") return { text: "⚪ Vencida",               bg: "#f0f0f0", color: "#888" };
  if (ad.status === "approved" && ad.payment_status === "paid") {
    if (isExpired(ad)) return { text: "⚪ Vencida", bg: "#f0f0f0", color: "#888" };
    return { text: "✅ Activa", bg: "#E1F5EE", color: "#0F6E56" };
  }
  if (ad.status === "approved" && ad.payment_status !== "paid")    return { text: "💳 Aprobada, falta pagar", bg: "#e8f4fd", color: "#009ee3" };
  return { text: ad.status, bg: "#f0f0f0", color: "#888" };
};

export default function MyAd() {
  const { currentUser, logout } = useApp();
  const [ads, setAds] = useState([]);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [payingId, setPayingId] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!currentUser) return;
    adsAPI.getMine(currentUser.id)
      .then(({ ads, messages }) => { setAds(ads); setMessages(messages); })
      .finally(() => setLoading(false));
  }, [currentUser]);

  const handlePay = async (adId) => {
    setError("");
    setPayingId(adId);
    try {
      const { initPoint } = await adsAPI.createPreference(adId);
      window.location.href = initPoint;
    } catch (e) {
      setError(e.message);
      setPayingId(null);
    }
  };

  if (loading) return <div style={s.wrap}><p>Cargando...</p></div>;

  return (
    <div style={s.wrap}>
      <div style={s.header}>
        <p style={s.title}>Mis publicidades</p>
        <button style={s.logoutBtn} onClick={logout}>Salir</button>
      </div>

      {ads.length === 0 && <p style={s.empty}>Todavia no tenes ninguna solicitud de publicidad.</p>}

      {ads.map(ad => {
        const info = getStatusInfo(ad);
        const adMessages = messages.filter(m => m.ad_id === ad.id);
        const needsPayment = ad.status === "approved" && ad.payment_status !== "paid";
        return (
          <div key={ad.id} style={s.card}>
            <div style={s.cardHeader}>
              <p style={s.businessName}>{ad.business_name}</p>
              <span style={{...s.badge, background: info.bg, color: info.color}}>{info.text}</span>
            </div>
            <p style={s.desc}>{ad.description}</p>

            {ad.status === "approved" && ad.payment_status === "paid" && ad.end_date && (
              <p style={s.expiryText}>Activa hasta el {new Date(ad.end_date).toLocaleDateString("es-AR")}</p>
            )}

            {needsPayment && (
              <div style={s.payBox}>
                <p style={s.payText}>Tu publicidad fue aprobada. Pagala para que empiece a mostrarse.</p>
                {error && payingId === ad.id && <p style={s.errorText}>{error}</p>}
                <button style={s.payBtn} onClick={() => handlePay(ad.id)} disabled={payingId === ad.id}>
                  {payingId === ad.id ? "Redirigiendo..." : `💳 Pagar ${formatPrice(ad.amount)} y activar`}
                </button>
              </div>
            )}

            {adMessages.length > 0 && (
              <div style={s.messagesBox}>
                <p style={s.messagesTitle}>Mensajes de los administradores</p>
                {adMessages.map(m => (
                  <div key={m.id} style={s.messageItem}>
                    <p style={s.messageText}>{m.message}</p>
                    <p style={s.messageDate}>{new Date(m.created_at).toLocaleDateString("es-AR")}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

const s = {
  wrap:{maxWidth:600,margin:"0 auto",padding:"24px 16px"},
  header:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20},
  title:{fontSize:22,fontWeight:700,color:"#111"},
  logoutBtn:{background:"none",border:"1px solid #ddd",borderRadius:8,padding:"8px 14px",fontSize:13,cursor:"pointer",color:"#555"},
  empty:{color:"#888",textAlign:"center",padding:"40px 0"},
  card:{background:"#fff",borderRadius:14,border:"0.5px solid #e0e0e0",padding:18,marginBottom:16},
  cardHeader:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8,gap:10},
  businessName:{fontSize:16,fontWeight:600,color:"#111"},
  badge:{fontSize:11,fontWeight:600,padding:"4px 10px",borderRadius:20,whiteSpace:"nowrap"},
  desc:{fontSize:14,color:"#666",lineHeight:1.5,marginBottom:8},
  messagesBox:{marginTop:12,background:"#f9f9f9",borderRadius:10,padding:12},
  messagesTitle:{fontSize:12,fontWeight:600,color:"#555",marginBottom:8},
  messageItem:{marginBottom:8,paddingBottom:8,borderBottom:"0.5px solid #eee"},
  messageText:{fontSize:14,color:"#333",margin:0},
  messageDate:{fontSize:11,color:"#aaa",margin:"4px 0 0"},
  expiryText:{fontSize:12,color:"#0F6E56",marginBottom:8},
  payBox:{background:"#e8f4fd",borderRadius:10,padding:14,marginTop:8},
  payText:{fontSize:13,color:"#333",marginBottom:10},
  payBtn:{width:"100%",background:"#009ee3",color:"#fff",border:"none",borderRadius:10,padding:"12px",fontSize:14,fontWeight:600,cursor:"pointer"},
  errorText:{color:"#E24B4A",fontSize:12,marginBottom:8},
};
